import { useMutation } from '@apollo/client';
import { Button, Form, Input, Modal } from 'antd';
import { encode } from 'base-64';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useNotification from '../../../hooks/layout/useNotification';
import useSpinner from '../../../hooks/layout/useSpinner';
import { CHANGE_PASSWORD } from '../Profile.gql';

interface Props {
    visible: boolean;
    setVisible: Dispatch<SetStateAction<boolean>>;
}

const ResetPassword = ({ visible, setVisible }: Props) => {
    const intl = useIntl();
    const [form] = Form.useForm();
    const { setLoading } = useSpinner();
    const { setSuccessNotification, setErrorNotification } = useNotification();
    const [changePassword, { data: changePasswordData, loading: changePasswordLoading }]
        = useMutation(CHANGE_PASSWORD,
            { errorPolicy: "all" });

    useEffect(() => {
        setLoading(changePasswordLoading)// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changePasswordLoading])

    useEffect(() => {
        if (changePasswordData && changePasswordData.changePassword && changePasswordData.changePassword.status) {
            if (changePasswordData.changePassword.status === 'SUCCESS') {
                setSuccessNotification(intl.formatMessage({ id: 'CHANGE_PASSWORD_SUCCESS' }));
                setVisible(false)
            } else {
                setErrorNotification(intl.formatMessage({ id: `ERROR_${changePasswordData.changePassword.status}` }));
            }
        } else {
           
        }// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changePasswordData])

    const onFinish = (fieldsValue: any) => {
        const variables: any = {
            password: encode(fieldsValue.current_password),
            newPassword: encode(fieldsValue.new_password)
        };
        changePassword({ variables });
    }


    return (
        <>
            <Modal
                title={<FormattedMessage id='CHANGE_PASSWORD' />}
                onCancel={() => { setVisible(false) }}
                open={visible}
                footer={null}
            >
                <div className='m-reset-password-container'>
                    <Form
                        onFinish={onFinish}
                        form={form}
                    >
                        <Form.Item
                            label={intl.formatMessage({ id: 'RESET_PASSWORD_CURRENT' })}
                            name='current_password'
                            rules={[
                                { required: true, message: intl.formatMessage({ id: 'RESET_PASSWORD_CURRENT_REQUIRED' }) },
                                {
                                    pattern: /[A-Za-z0-9]{6,19}$/,
                                    message: intl.formatMessage({ id: 'AUTH_REGISTER_FORM_PASSWORD_INVALID' })
                                }
                            ]}
                        >
                            <Input.Password placeholder={intl.formatMessage({ id: 'LOGIN_PASSWORD_PLACEHOLDER' })} />
                        </Form.Item>
                        <Form.Item
                            label={intl.formatMessage({ id: 'RESET_PASSWORD_NEW' })}
                            name='new_password'
                            rules={[
                                { required: true, message: intl.formatMessage({ id: 'RESET_PASSWORD_NEW_REQUIRED' }) },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            label={intl.formatMessage({ id: 'RESET_PASSWORD_CONFIRM' })}
                            name='confirm_password'
                            dependencies={['new_password']}
                            rules={[{ required: true, message: intl.formatMessage({ id: 'AUTH_REGISTER_FORM_PASSWORD_REQUIRED' }) },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('new_password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error(intl.formatMessage({ id: 'AUTH_REGISTER_FORM_PASSWORD_NOT_MATCHED' })));
                                },
                            })]}>
                            <Input.Password />
                        </Form.Item>
                        <Form.Item className="form-button">
                            <Button type="primary" htmlType="submit">
                                {<FormattedMessage id='BTN_SAVE' />}
                            </Button>
                        </Form.Item>

                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default ResetPassword;